import jss from 'jss';
import preset from 'jss-preset-default';

import jssStyles from './prebuild/jss';

jss.setup(preset());

jss.createStyleSheet(jssStyles).attach();
